import { render, staticRenderFns } from "./PackageUp.vue?vue&type=template&id=6b1d3bb0"
import script from "./PackageUp.vue?vue&type=script&lang=js"
export * from "./PackageUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports